package com.xtream.data_kmp.dto

import androidx.room3.Embedded
import androidx.room3.Relation
import com.xtream.data_kmp.db.tables.LiveStreamOrderEntity

data class LiveStreamWithSortOrder(
    @Embedded val liveStream: LiveStream,
    @Relation(
        parentColumns = ["streamId"],
        entityColumns = ["streamId"]
    )
    val order: LiveStreamOrderEntity?
)